import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../useAuth";
import { endpoints, getPath } from "./apiUtils";

export const useOrganization = (organizationId) => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.organizations,
    path: [organizationId],
  });
  return useQuery(
    ["organizations", organizationId],
    async () => {
      return axios
        .get(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data);
    },
    {
      enabled: !!organizationId,
    }
  );
};

export const useOrganizationUsers = (organizationId) => {
  const { getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.organizations,
    path: [organizationId, "users"],
  });

  return useQuery(
    ["organization", organizationId, "users"],
    async () =>
      axios
        .get(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data),
    { enabled: !!organizationId }
  );
};

export const useOrganizationUserDelete = (organizationId, userId) => {
  const { getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.organizations,
    path: [organizationId, "users", userId],
  });

  const queryClient = useQueryClient();

  return useMutation(
    async () =>
      axios
        .delete(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "organization",
          organizationId,
          "users",
        ]);
      },
    }
  );
};

export const useOrganizationSettings = (organizationId) => {
  const { getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.settings,
    path: ["Organiation", organizationId],
  });

  return useQuery(
    ["settings", "organization", organizationId],
    async () => {
      return axios.get(path, {
        headers: { Authorization: await getAccessToken() },
      });
    },
    {
      enabled: !!organizationId,
    }
  );
};

export const useOrganizationBilling = (organizationId) => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.organizations,
    path: [organizationId, "contact"],
  });

  return useQuery(
    ["organizations", organizationId, "contact"],
    async () => {
      return axios
        .get(path, {
          headers: { Authorization: await getAccessToken() },
        })
        .then((r) => r.data);
    },
    {
      enabled: !!organizationId,
    }
  );
};
